var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.82 12.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #8b8c9e;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.32 10.7 .5 10.7 .5 2.99 14.47 .5 22.32 2.99 22.32 10.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.69,
    y: 5.6,
    width: 2.43,
    height: 4.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.52,
    y: 5.6,
    width: 2.43,
    height: 2.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.45,
    y: 5.6,
    width: 5.63,
    height: 2.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.75,10.72c0,.72-.58,1.3-1.3,1.3s-1.3-.58-1.3-1.3h2.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.74,10.72c0,.72-.58,1.3-1.3,1.3s-1.3-.58-1.3-1.3h2.59Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHome);
export default __webpack_public_path__ + "static/media/MobileHome.06be52e9.svg";
export { ForwardRef as ReactComponent };